import { useQuery } from '@tanstack/react-query';
import { useSession } from '@/contexts/LitSessionProvider';
export default function useIsAdmin() {
  const {
    PKP
  } = useSession();
  const {
    data: isAdmin,
    isLoading,
    isFetching
  } = useQuery({
    queryKey: ['isAdmin', PKP?.ethAddress],
    queryFn: async (): Promise<boolean> => {
      const data = await fetch(`/api/admin/check-admin`).then(res => res.json());
      if (data?.status === 'authorized') {
        return true;
      }
      return false;
    },
    staleTime: 1000 * 60 * 5 // 5 minutes
  });
  return {
    isAdmin,
    isLoading,
    isFetching
  };
}